/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { getRouteInitData, State } from '@gh/common-shared';
import { FocusedCell } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { ComponentItem } from '../../resources/component-and-item-details.model';
import { ComponentDetailsFormState } from '../component-details-tab-container/component-details-form.service';
import { ComponentDetailsCommandService } from './component-details-command.service';
import { ComponentDetailsItemsGridDefinition } from './component-details-items-grid-definition.service';
import { ComponentDetailsItemsState } from './component-details-items.state';

@Component({
  selector: 'gh-component-details-items-tab',
  template: require('./component-details-items-tab.component.html'),
  styles: [require('./component-details-items-tab.component.scss')],
  providers: [ComponentDetailsItemsGridDefinition],
})
export class ComponentDetailsItemsTabComponent implements OnInit {

  constructor(private route: ActivatedRoute,
              public gridDefinition: ComponentDetailsItemsGridDefinition,
              private itemsState: State<ComponentDetailsItemsState>,
              private commands: ComponentDetailsCommandService,
              private form: ComponentDetailsFormState) {

  }

  get editable(): boolean {
    return this.form.editable && !this.form.locked;
  }

  get items(): Observable<ComponentItem[]> {
    return this.itemsState.select((state) => state.items);
  }

  get total(): number {
    return this.form.cost;
  }

  get focusedCell(): Observable<Maybe<FocusedCell>> {
    return this.itemsState.select((state) => state.focusedCell);
  }

  ngOnInit(): void {
    const { itemsGridLayout } = getRouteInitData(this.route);

    this.gridDefinition.bind(itemsGridLayout);
  }

  onAdd(): void {
    this.commands.addItem();
  }

  onRemove(item: ComponentItem): void {
    this.commands.removeItem(item.uniqueId);
  }
}
